import { TranslatableText, WithDefaultValue, WithFieldController } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

export type PasswordFieldValue = string | null;

type PasswordFieldProps = WithFieldController<unknown> &
   WithDefaultValue<PasswordFieldValue> & {
      readonly label: TranslatableText;
      readonly disabled?: boolean;
      readonly testId?: string;
   };

export const PasswordField = (props: PasswordFieldProps): JSX.Element => {
   return (
      <PasswordInput
         testId={props.testId ?? 'password'}
         defaultValue={props.defaultValue}
         label={props.label}
         controller={props.controller}
         disabled={props.disabled}
      />
   );
};
